import { configureStore } from "@reduxjs/toolkit"
import { api } from "./api"
import globalReducer from "./global-slice"

declare global {
  interface Window {
    __APP_STORE__?: typeof store
  }
}

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    global: globalReducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
})

if (process.env.NODE_ENV === "development") {
  window.__APP_STORE__ = store
}
